export const TAFFI_DEV_MODE = 'taffiDevMode';
export const STORE_DEV_MODE_ATTR = 'taffi_store_dev_mode_attr';
export const devModeAllowedKeys = [
    'approved',
    'showTaffiWidget',
    'showFloatingButton',
    'showAskAmiraCardPDP',
    'enableProductSpecificQuestion',
    'plpURLParams',
    'showDressItRightCardPDP',
    'plpWidgetReplaceItemCard',
    'displayTitlePDP',
    'displayTitlePLP',
    'styleLayoutVersion',
    'enableStyleWidget',
    'enableListingStyles',
    'enableSearchWidget',
    'enableSingleProductStyling',
    'enableEngagingSlider',
];
